import { useIdleTimer } from 'react-idle-timer';
import analyticsIdManager from '../services/analyticsIdManager';
import { CONFIG } from '../config';

export const useActivityWatcher = (): void => {
  useIdleTimer({
    onAction: () => {
      analyticsIdManager.markAsActive();
    },
    debounce: CONFIG.ACTIVITY_DEBOUNCE_TIME * 1000,
    events: ['mousedown'],
  });
};
